"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCommerceAPI = exports.CustomerProvider = exports.CustomerProductListsProvider = exports.CustomerProductListsContext = exports.CustomerContext = exports.CommerceAPIProvider = exports.CommerceAPIContext = exports.BasketProvider = exports.BasketContext = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * Provider and associated hook for accessing the Commerce API in React components.
 */
// @ts-ignore
const CommerceAPIContext = exports.CommerceAPIContext = /*#__PURE__*/(0, _react.createContext)();
const CommerceAPIProvider = exports.CommerceAPIProvider = CommerceAPIContext.Provider;
const useCommerceAPI = () => (0, _react.useContext)(CommerceAPIContext);

/**
 * There are a few sources of global state in the react retail storefront.
 * Using React Context we implement a simple shared global state allowing
 * you can update and use either state from anywhere in the application.
 *
 * If your global state needs require a more robust solution, these contexts can be
 * replaced by a third party state management library of your choosing, such as MobX
 * or Redux.
 *
 * To use these context's simply import them into the component requiring context
 * like the below example:
 *
 * import React, {useContext} from 'react'
 * import {BasketContext} from 'components/_app-config'
 *
 * export const Avatar = () => {
 *    const {customer} = useContext(BasketContext)
 *    return <div>{customer.name}</div>
 * }
 *
 */

/************ Basket ************/
// @ts-ignore
exports.useCommerceAPI = useCommerceAPI;
const BasketContext = exports.BasketContext = /*#__PURE__*/(0, _react.createContext)();
const BasketProvider = exports.BasketProvider = BasketContext.Provider;

/************ Customer ************/
// @ts-ignore
const CustomerContext = exports.CustomerContext = /*#__PURE__*/(0, _react.createContext)();
const CustomerProvider = exports.CustomerProvider = CustomerContext.Provider;

/************ Customer Product Lists ************/
const CPLInitialValue = {
  // this is an object of product lists
  // keyed by list id, initial state
  // being undefined indicates the
  // product lists is not initialized
  productLists: undefined
};
const CPLActionTypes = {
  RECEIVE_LISTS: 'RECEIVE_LISTS',
  RECEIVE_LIST: 'RECEIVE_LIST',
  CREATE_LIST_ITEM: 'CREATE_LIST_ITEM',
  UPDATE_LIST_ITEM: 'UPDATE_LIST_ITEM',
  REMOVE_LIST_ITEM: 'REMOVE_LIST_ITEM',
  RESET: 'RESET'
};
const CustomerProductListsContext = exports.CustomerProductListsContext = /*#__PURE__*/(0, _react.createContext)(CPLInitialValue);
// eslint-disable-next-line react/prop-types
const CustomerProductListsProvider = ({
  children
}) => {
  const [state, dispatch] = (0, _react.useReducer)((state, {
    type,
    payload
  }) => {
    switch (type) {
      case CPLActionTypes.RECEIVE_LISTS:
        {
          const productLists = payload.reduce((acc, curr) => {
            return _objectSpread(_objectSpread({}, acc), {}, {
              [curr.id]: curr
            });
          }, {});
          return _objectSpread(_objectSpread({}, state), {}, {
            productLists
          });
        }
      case CPLActionTypes.RECEIVE_LIST:
        {
          const {
            id
          } = payload;
          // Tips: if you are unfamiliar with the concept of
          // reducers, keep in mind that reducers must be pure.
          // For an action like this, you must update every
          // level of nested data to avoid unexpected side effects
          return _objectSpread(_objectSpread({}, state), {}, {
            productLists: _objectSpread(_objectSpread({}, state.productLists), {}, {
              [id]: payload
            })
          });
        }
      case CPLActionTypes.CREATE_LIST_ITEM:
        {
          var _state$productLists$l;
          const {
            listId,
            item
          } = payload;
          const {
            productId
          } = item;
          const items = ((_state$productLists$l = state.productLists[listId]) === null || _state$productLists$l === void 0 ? void 0 : _state$productLists$l.customerProductListItems) || [];

          // if the item is already added to the list
          // we update the existing item
          const existingItemIndex = items.findIndex(i => i.productId === productId);
          if (existingItemIndex >= 0) {
            items[existingItemIndex] = item;
          } else {
            items.push(item);
          }
          return _objectSpread(_objectSpread({}, state), {}, {
            productLists: _objectSpread(_objectSpread({}, state.productLists), {}, {
              [listId]: _objectSpread(_objectSpread({}, state.productLists[listId]), {}, {
                customerProductListItems: items
              })
            })
          });
        }
      case CPLActionTypes.UPDATE_LIST_ITEM:
        {
          var _state$productLists$l2;
          const {
            listId,
            item
          } = payload;
          const items = (_state$productLists$l2 = state.productLists[listId].customerProductListItems) === null || _state$productLists$l2 === void 0 ? void 0 : _state$productLists$l2.map(listItem => {
            if (listItem.id === item.id) {
              return _objectSpread(_objectSpread({}, listItem), item);
            }
            return listItem;
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            productLists: _objectSpread(_objectSpread({}, state.productLists), {}, {
              [listId]: _objectSpread(_objectSpread({}, state.productLists[listId]), {}, {
                customerProductListItems: items
              })
            })
          });
        }
      case CPLActionTypes.REMOVE_LIST_ITEM:
        {
          var _productLists$listId$;
          const {
            listId,
            itemId
          } = payload;
          const productLists = _objectSpread({}, state.productLists);
          productLists[listId].customerProductListItems = (_productLists$listId$ = productLists[listId].customerProductListItems) === null || _productLists$listId$ === void 0 ? void 0 : _productLists$listId$.filter(listItem => {
            return listItem.id !== itemId;
          });
          return _objectSpread(_objectSpread({}, state), {}, {
            productLists
          });
        }
      case CPLActionTypes.RESET:
        {
          return _objectSpread({}, CPLInitialValue);
        }
      default:
        throw new Error('Unknown action.');
    }
  }, CPLInitialValue);
  const actions = {
    receiveLists: lists => dispatch({
      type: CPLActionTypes.RECEIVE_LISTS,
      payload: lists
    }),
    receiveList: list => dispatch({
      type: CPLActionTypes.RECEIVE_LIST,
      payload: list
    }),
    createListItem: (listId, item) => dispatch({
      type: CPLActionTypes.CREATE_LIST_ITEM,
      payload: {
        listId,
        item
      }
    }),
    updateListItem: (listId, item) => dispatch({
      type: CPLActionTypes.UPDATE_LIST_ITEM,
      payload: {
        listId,
        item
      }
    }),
    removeListItem: (listId, itemId) => dispatch({
      type: CPLActionTypes.REMOVE_LIST_ITEM,
      payload: {
        listId,
        itemId
      }
    }),
    reset: () => dispatch({
      type: CPLActionTypes.RESET
    })
  };
  return (
    /*#__PURE__*/
    // @ts-ignore
    _react.default.createElement(CustomerProductListsContext.Provider, {
      value: {
        state,
        actions
      }
    }, children)
  );
};
exports.CustomerProductListsProvider = CustomerProductListsProvider;